import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService } from './auth.service';
import { map, Observable } from 'rxjs';
import {
  CarnetAllRequest,
  CarnetAllResponse,
  CarnetRequest,
  CarnetResponse,
  HealthPolicyDataRequest,
  HealthPolicyDataResponse,
  PolicyDataResponse,
  PolicyDataResquet } from '../interfaces/marbetes.interface';
import { ApiResponse } from '../interfaces/common.interfaces';

@Injectable({
  providedIn: 'root'
})
export class MarbetesService {
  private apiUrl = environment.int365_dom + '/api/v1';
  private apiUrlV2 = environment.int365_dom + '/api/v2';
  private apiUrlSCAfiliado = environment.int365_dom + '/api/Afiliado365'
  constructor(private http: HttpClient, private authService: AuthService) { }


  getPolicyData(
    request: PolicyDataResquet
  ): Observable<PolicyDataResponse> {
    return this.http
      .get<ApiResponse<PolicyDataResponse>>(
        `${this.apiUrl}/Marbete/PolicyData`,
        this.getHttpOptions(request)
      )
      .pipe(
        map((response) => {
          try { return response.data }
          catch (error: any) { return error }
        }),
      );
  }

  getCarnets(
    request: CarnetRequest
  ): Observable<CarnetResponse> {
    return this.http
      .get<ApiResponse<CarnetResponse>>(
        `${this.apiUrlV2}/documents/carnet`,
        this.getHttpOptions(request)
      )
      .pipe(
        map((response) => {
          try { return response.data }
          catch (error: any) { return error }
        }),
      );
  }
  getAllCarnets(
    request: CarnetAllRequest
  ): Observable<CarnetAllResponse> {
    return this.http
      .get<ApiResponse<CarnetAllResponse>>(
        `${this.apiUrlV2}/documents`,
        this.getHttpOptions(request)
      )
      .pipe(
        map((response) => {
          try { return response.data }
          catch (error: any) { return error }
        }),
      );
  }

  // SALUD------------------------------------------
  getHealthPolicyData(
    request: HealthPolicyDataRequest
  ): Observable<HealthPolicyDataResponse> {
    return this.http
      .post<HealthPolicyDataResponse>(
        `${this.apiUrlSCAfiliado}/poliza/consultar`,
        request,
        this.getHttpOptions(),
      )
      .pipe(
        map((response) => {
          try { return response }
          catch (error: any) { return error }
        }),
      );
  }

  // Autenticación
  private getHttpOptions(params?: any, header?: any) {
    const token = this.authService.getToken();
    if (!token) throw new Error('No token found');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...header
    });

    return {
      headers,
      params: params
        ? new HttpParams({ fromObject: this.formatParams(params) })
        : undefined,
    };
  }

  // Formato de parámetros
  private formatParams(params: any): { [key: string]: string } {
    const formattedParams: { [key: string]: string } = {};

    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === undefined) return;

      if (value instanceof Date) {
        formattedParams[key] = value.toISOString().split('T')[0];
      } else {
        formattedParams[key] = String(value);
      }
    });

    return formattedParams;
  }
}
